export const PAYMENT_TERMS = [
  {
    value: 'PREPAID',
    label: 'Prepaid',
  },
  {
    value: 'POST_PAID',
    label: 'Post-paid',
  },
  {
    value: 'INSTALLMENTS',
    label: 'Installments',
  },
];

export const PAYMENT_TERMS_MAPPING = {
  PREPAID: 'Prepaid',
  POST_PAID: 'Post-paid',
  INSTALLMENTS: 'Installments',
};
